import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { currentLanguage, switchLanguage } = useLanguage();

  return (
    <div className="language-toggle">
      <button
        className={`lang-btn ${currentLanguage === 'japanese' ? 'active' : ''}`}
        onClick={() => switchLanguage('japanese')}
      >
        日本語
      </button>
      <button
        className={`lang-btn ${currentLanguage === 'english' ? 'active' : ''}`}
        onClick={() => switchLanguage('english')}
      >
        English
      </button>
    </div>
  );
};

export default LanguageToggle; 